var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 383.857,
    viewBox: "0 0 500 383.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_47953",
    "data-name": "Group 47953",
    transform: "translate(0 -58.73)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47875",
    "data-name": "Group 47875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow--inject-214"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "path--inject-214",
    cx: 193.89,
    cy: 11.32,
    rx: 193.89,
    ry: 11.32,
    transform: "translate(56.11 419.947)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47873",
    "data-name": "Group 47873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103892",
    "data-name": "Path 103892",
    d: "M238.4,341.53H45.305a5.709,5.709,0,0,1-5.7-5.71V64.39a5.71,5.71,0,0,1,5.7-5.66H238.4a5.711,5.711,0,0,1,5.71,5.71h0V335.82A5.71,5.71,0,0,1,238.4,341.53ZM45.305,58.93a5.46,5.46,0,0,0-5.45,5.46V335.82a5.459,5.459,0,0,0,5.45,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V64.39a5.471,5.471,0,0,0-5.46-5.46Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103893",
    "data-name": "Path 103893",
    d: "M454.7,341.53h-193.1a5.719,5.719,0,0,1-5.71-5.71V64.39a5.721,5.721,0,0,1,5.71-5.66H454.7a5.71,5.71,0,0,1,5.69,5.66V335.82A5.71,5.71,0,0,1,454.7,341.53Zm-193.1-282.6a5.47,5.47,0,0,0-5.46,5.46V335.82a5.469,5.469,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V64.39a5.471,5.471,0,0,0-5.46-5.46Z",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47874",
    "data-name": "Group 47874"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28502",
    "data-name": "Rectangle 28502",
    width: 41.21,
    height: 0.25,
    transform: "translate(44.73 392.21)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28503",
    "data-name": "Rectangle 28503",
    width: 41.33,
    height: 0.25,
    transform: "translate(128.61 390.21)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28504",
    "data-name": "Rectangle 28504",
    width: 10,
    height: 0.25,
    transform: "translate(213.72 390.21)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28505",
    "data-name": "Rectangle 28505",
    width: 46.25,
    height: 0.25,
    transform: "translate(77.52 398.75)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28506",
    "data-name": "Rectangle 28506",
    width: 21.6,
    height: 0.25,
    transform: "translate(262.14 392.08)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28507",
    "data-name": "Rectangle 28507",
    width: 27.93,
    height: 0.25,
    transform: "translate(292.64 392.08)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28508",
    "data-name": "Rectangle 28508",
    width: 62.44,
    height: 0.25,
    transform: "translate(392.83 396.31)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28509",
    "data-name": "Rectangle 28509",
    width: 500,
    height: 0.25,
    transform: "translate(0 382.398)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47897",
    "data-name": "Group 47897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47895",
    "data-name": "Group 47895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47878",
    "data-name": "Group 47878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47876",
    "data-name": "Group 47876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103894",
    "data-name": "Path 103894",
    d: "M334.835,79.48l-2.493,34.275a4.906,4.906,0,0,1-1.393,3.09,4.968,4.968,0,0,1-3.607,1.584H299.85a4.319,4.319,0,0,1-4.346-4.674L298,79.48a5.089,5.089,0,0,1,5-4.673h27.492A4.3,4.3,0,0,1,334.835,79.48Z",
    fill: "#a5ffcc",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47877",
    "data-name": "Group 47877"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3960",
    "data-name": "Ellipse 3960",
    cx: 9.221,
    cy: 7.47,
    rx: 9.221,
    ry: 7.47,
    transform: "translate(306.187 102.493) rotate(-78.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103895",
    "data-name": "Path 103895",
    d: "M326.377,116.066H301.218c-1.6,0-2.7-.765-2.74-1.839-.058-1.555,8.1-8.3,15.841-7.719.028,0,.056,0,.085,0h.092a21.284,21.284,0,0,1,12.959,4.991C331.188,114.45,327.655,116.066,326.377,116.066Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47886",
    "data-name": "Group 47886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47879",
    "data-name": "Group 47879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103896",
    "data-name": "Path 103896",
    d: "M193.021,117.18a10.594,10.594,0,0,1-10.506-9.593,8.952,8.952,0,0,1,8.9-9.837,10.6,10.6,0,0,1,10.508,9.594A8.952,8.952,0,0,1,193.021,117.18Zm-1.175-14.267a4.194,4.194,0,0,0-4.173,4.609,4.963,4.963,0,0,0,4.923,4.495,4.194,4.194,0,0,0,4.174-4.608A4.966,4.966,0,0,0,191.846,102.913Z",
    fill: "#b7ffd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47885",
    "data-name": "Group 47885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47880",
    "data-name": "Group 47880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103897",
    "data-name": "Path 103897",
    d: "M193.5,102.164l-3.684.046-1.954-23.717,3.684-.046Z",
    fill: "#b7ffd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47884",
    "data-name": "Group 47884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47881",
    "data-name": "Group 47881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103898",
    "data-name": "Path 103898",
    d: "M195.039,79.511l-6.917.086-.3-3.688,6.917-.086Z",
    fill: "#b7ffd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47882",
    "data-name": "Group 47882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103899",
    "data-name": "Path 103899",
    d: "M195.435,84.25l-6.5.081-.3-3.688,6.5-.081Z",
    fill: "#b7ffd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47883",
    "data-name": "Group 47883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103900",
    "data-name": "Path 103900",
    d: "M196,90.934,190.319,91l-.3-3.688,5.677-.071Z",
    fill: "#b7ffd6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47894",
    "data-name": "Group 47894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47887",
    "data-name": "Group 47887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103901",
    "data-name": "Path 103901",
    d: "M79.309,318.769a9.036,9.036,0,0,0,8.869,8.289h84.49a7.6,7.6,0,0,0,7.723-7.4,8.545,8.545,0,0,0-.012-.889,9.038,9.038,0,0,0-8.869-8.281H87.02A7.626,7.626,0,0,0,79.309,318.769Z",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47888",
    "data-name": "Group 47888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103902",
    "data-name": "Path 103902",
    d: "M180.388,319.657a5.419,5.419,0,0,1-.074.8,9.049,9.049,0,0,0-8.84-7.97l-89.853.14a7.7,7.7,0,0,1,5.4-2.14h84.49a8.775,8.775,0,0,1,8.879,9.17Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47890",
    "data-name": "Group 47890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47889",
    "data-name": "Group 47889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103903",
    "data-name": "Path 103903",
    d: "M165.93,314.484l.283,4.042,3.787-1.4.86,2-3.869,1.276,2.7,3.391-1.746,1.277-2.63-3.525-2.1,3.525-1.87-1.277,2.191-3.391-4.011-1.276.578-1.983,4.019,1.352-.28-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103904",
    "data-name": "Path 103904",
    d: "M142.823,314.484l.283,4.042,3.787-1.4.859,2-3.868,1.276,2.7,3.391-1.746,1.277-2.63-3.525-2.1,3.525-1.871-1.277,2.192-3.391-4.011-1.276.578-1.983,4.019,1.352-.28-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103905",
    "data-name": "Path 103905",
    d: "M119.716,314.484l.283,4.042,3.787-1.4.859,2-3.868,1.276,2.7,3.391-1.745,1.277-2.63-3.525-2.1,3.525-1.871-1.277,2.192-3.391-4.011-1.276.578-1.983,4.019,1.352-.28-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103906",
    "data-name": "Path 103906",
    d: "M96.609,314.484l.282,4.042,3.788-1.4.859,2-3.868,1.276,2.7,3.391-1.745,1.277L96,321.537l-2.1,3.525-1.871-1.277,2.192-3.391-4.011-1.276.578-1.983,4.019,1.352-.28-4Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47893",
    "data-name": "Group 47893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47891",
    "data-name": "Group 47891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103907",
    "data-name": "Path 103907",
    d: "M152.735,307.569H148.8l.018-1h3.938Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47892",
    "data-name": "Group 47892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103908",
    "data-name": "Path 103908",
    d: "M169.673,307.569H156.82l.018-1h12.854Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47896",
    "data-name": "Group 47896",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103909",
    "data-name": "Path 103909",
    d: "M269.385,302.527l15.933,24.531L337.877,274.5a.521.521,0,0,0-.69-.778L287.1,312.982l-9.458-15.251Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Device_2",
    "data-name": "Device 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47898",
    "data-name": "Group 47898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103910",
    "data-name": "Path 103910",
    d: "M259.856,127.955l-37.739,141.15h12.7l37.323-141.15Z",
    fill: "#fff",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103911",
    "data-name": "Path 103911",
    d: "M279.449,127.955l-37.74,141.15h25.182l37.323-141.15Z",
    fill: "#fff",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47915",
    "data-name": "Group 47915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47912",
    "data-name": "Group 47912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47902",
    "data-name": "Group 47902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47901",
    "data-name": "Group 47901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47900",
    "data-name": "Group 47900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47899",
    "data-name": "Group 47899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103912",
    "data-name": "Path 103912",
    d: "M415.31,255.315l7.962-113.3a6.243,6.243,0,0,0-6.335-6.772L219.2,135.41a7.413,7.413,0,0,0-7.288,6.784l-7.961,113.3a6.243,6.243,0,0,0,6.335,6.772l197.735-.171A7.413,7.413,0,0,0,415.31,255.315Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47911",
    "data-name": "Group 47911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47910",
    "data-name": "Group 47910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103913",
    "data-name": "Path 103913",
    d: "M412.773,252.844l7.961-113.3a6.244,6.244,0,0,0-6.335-6.772l-197.734.172a7.412,7.412,0,0,0-7.288,6.784l-7.962,113.3a6.245,6.245,0,0,0,6.336,6.773l197.734-.172A7.413,7.413,0,0,0,412.773,252.844Z",
    fill: "#2bb567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103914",
    "data-name": "Path 103914",
    d: "M407.531,254.516a2.154,2.154,0,0,1-1.493.579l-197.735.172a2.343,2.343,0,0,1-2.322-2.477l7.961-113.3a2.134,2.134,0,0,1,.677-1.435,2.158,2.158,0,0,1,1.493-.579l197.734-.171a2.342,2.342,0,0,1,2.322,2.477l-7.961,113.3A2.127,2.127,0,0,1,407.531,254.516Z",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47904",
    "data-name": "Group 47904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103915",
    "data-name": "Path 103915",
    d: "M341.759,192.229H272.353a2.546,2.546,0,0,0-2.477,2.233l-1.063,10.15a1.979,1.979,0,0,0,2.011,2.233h69.4a2.546,2.546,0,0,0,2.478-2.233l1.062-10.15A1.979,1.979,0,0,0,341.759,192.229Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47903",
    "data-name": "Group 47903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103916",
    "data-name": "Path 103916",
    d: "M280.608,233.685H269.777a2.546,2.546,0,0,0-2.477,2.233l-1.062,10.15a1.979,1.979,0,0,0,2.01,2.233h10.831a2.547,2.547,0,0,0,2.478-2.233l1.062-10.15A1.979,1.979,0,0,0,280.608,233.685Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103917",
    "data-name": "Path 103917",
    d: "M299.309,233.685H288.478A2.546,2.546,0,0,0,286,235.918l-1.062,10.15a1.979,1.979,0,0,0,2.01,2.233H297.78a2.547,2.547,0,0,0,2.478-2.233l1.062-10.15A1.979,1.979,0,0,0,299.309,233.685Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103918",
    "data-name": "Path 103918",
    d: "M318.01,233.685H307.179a2.546,2.546,0,0,0-2.477,2.233l-1.063,10.15a1.979,1.979,0,0,0,2.011,2.233h10.831a2.547,2.547,0,0,0,2.478-2.233l1.062-10.15A1.979,1.979,0,0,0,318.01,233.685Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103919",
    "data-name": "Path 103919",
    d: "M336.711,233.685H325.88a2.546,2.546,0,0,0-2.477,2.233l-1.063,10.15a1.979,1.979,0,0,0,2.011,2.233h10.831a2.547,2.547,0,0,0,2.478-2.233l1.062-10.15A1.979,1.979,0,0,0,336.711,233.685Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_103920",
    "data-name": "Path 103920",
    d: "M281.059,226.771h43.416a4.335,4.335,0,0,0,4.219-3.8l.522-4.983a3.371,3.371,0,0,0-3.424-3.8H282.376a4.336,4.336,0,0,0-4.22,3.8l-.521,4.983A3.37,3.37,0,0,0,281.059,226.771Z",
    fill: "none",
    stroke: "#220f6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103921",
    "data-name": "Path 103921",
    d: "M344.26,171.1H274.854a2.545,2.545,0,0,0-2.477,2.233l-1.062,10.149a1.979,1.979,0,0,0,2.01,2.233h69.406a2.545,2.545,0,0,0,2.477-2.233l1.063-10.149A1.98,1.98,0,0,0,344.26,171.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103922",
    "data-name": "Path 103922",
    d: "M280.793,199.537a2.191,2.191,0,0,0-2.226-2.472,2.819,2.819,0,0,0-2.743,2.472,2.191,2.191,0,0,0,2.226,2.472A2.818,2.818,0,0,0,280.793,199.537Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103923",
    "data-name": "Path 103923",
    d: "M288.427,199.537a2.192,2.192,0,0,0-2.226-2.472,2.819,2.819,0,0,0-2.743,2.472,2.191,2.191,0,0,0,2.226,2.472A2.818,2.818,0,0,0,288.427,199.537Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103924",
    "data-name": "Path 103924",
    d: "M296.06,199.537a2.19,2.19,0,0,0-2.225-2.472,2.817,2.817,0,0,0-2.743,2.472,2.19,2.19,0,0,0,2.225,2.472A2.818,2.818,0,0,0,296.06,199.537Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103927",
    "data-name": "Path 103927",
    d: "M283.294,178.4a2.19,2.19,0,0,0-2.225-2.472,2.819,2.819,0,0,0-2.743,2.472,2.191,2.191,0,0,0,2.225,2.473A2.819,2.819,0,0,0,283.294,178.4Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103928",
    "data-name": "Path 103928",
    d: "M290.928,178.4a2.191,2.191,0,0,0-2.226-2.472,2.819,2.819,0,0,0-2.743,2.472,2.192,2.192,0,0,0,2.226,2.473A2.819,2.819,0,0,0,290.928,178.4Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103929",
    "data-name": "Path 103929",
    d: "M298.561,178.4a2.19,2.19,0,0,0-2.225-2.472,2.819,2.819,0,0,0-2.743,2.472,2.191,2.191,0,0,0,2.225,2.473A2.819,2.819,0,0,0,298.561,178.4Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103930",
    "data-name": "Path 103930",
    d: "M306.2,178.4a2.191,2.191,0,0,0-2.226-2.472,2.819,2.819,0,0,0-2.743,2.472,2.192,2.192,0,0,0,2.226,2.473A2.819,2.819,0,0,0,306.2,178.4Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47909",
    "data-name": "Group 47909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47908",
    "data-name": "Group 47908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47905",
    "data-name": "Group 47905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103933",
    "data-name": "Path 103933",
    d: "M314.978,148.712l-.541,5.125a.956.956,0,0,1-.929.837.741.741,0,0,1-.752-.837l.541-5.125a2.662,2.662,0,0,0-2.7-3h-1.843a3.43,3.43,0,0,0-3.333,3l-.469,4.761h-1.681l.469-4.761a5.342,5.342,0,0,1,5.191-4.676h1.842A4.144,4.144,0,0,1,314.978,148.712Z",
    fill: "#fc3636"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47907",
    "data-name": "Group 47907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47906",
    "data-name": "Group 47906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103934",
    "data-name": "Path 103934",
    d: "M315.012,153.65l-1.054,9.986a1.3,1.3,0,0,1-1.269,1.144H302.654a1.012,1.012,0,0,1-1.028-1.144l1.054-9.986a1.3,1.3,0,0,1,.641-.969,1.246,1.246,0,0,1,.628-.174h10.035a1.065,1.065,0,0,1,.576.163A1.016,1.016,0,0,1,315.012,153.65Z",
    fill: "#fc3636"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47913",
    "data-name": "Group 47913"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    x1: 24.436,
    y2: 0.146,
    transform: "translate(368.872 132.108)",
    fill: "none",
    stroke: "#280c50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    x1: 8.637,
    y2: 0.038,
    transform: "translate(397.992 132.042)",
    fill: "none",
    stroke: "#280c50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47914",
    "data-name": "Group 47914",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103935",
    "data-name": "Path 103935",
    d: "M235.1,137.442h27.976l-28.44,117.825H212.058a4.317,4.317,0,0,1-4.1-5.387Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103936",
    "data-name": "Path 103936",
    d: "M275.5,137.442h11.877L258.932,255.267H247.055Z",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Device_1",
    "data-name": "Device 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47928",
    "data-name": "Group 47928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47926",
    "data-name": "Group 47926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47924",
    "data-name": "Group 47924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47923",
    "data-name": "Group 47923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47916",
    "data-name": "Group 47916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103937",
    "data-name": "Path 103937",
    d: "M86.654,100.663H92.33a9.519,9.519,0,0,0-9.621,10.344L94.757,283.3a11.267,11.267,0,0,0,11.068,10.344h-5.676A11.267,11.267,0,0,1,89.081,283.3l-12.049-172.3A9.52,9.52,0,0,1,86.654,100.663Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103938",
    "data-name": "Path 103938",
    d: "M86.654,100.663H92.33a9.519,9.519,0,0,0-9.621,10.344L94.757,283.3a11.267,11.267,0,0,0,11.068,10.344h-5.676c-5.714,0-11.469-4.631-11.868-10.344l-12.049-172.3C75.833,105.294,80.94,100.663,86.654,100.663Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_103939",
    "data-name": "Path 103939",
    d: "M101.841,293.649h69.5A9.519,9.519,0,0,0,180.96,283.3l-12.048-172.3a11.268,11.268,0,0,0-11.068-10.344h-69.5a9.52,9.52,0,0,0-9.621,10.344L90.773,283.3A11.268,11.268,0,0,0,101.841,293.649Z",
    fill: "#2bb567"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47917",
    "data-name": "Group 47917",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103940",
    "data-name": "Path 103940",
    d: "M157.656,103.982a7.85,7.85,0,0,1,7.7,7.2l12.048,172.3a6.269,6.269,0,0,1-6.367,6.852h-69.5a7.849,7.849,0,0,1-7.7-7.2l-12.048-172.3a6.269,6.269,0,0,1,6.367-6.852Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47918",
    "data-name": "Group 47918",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103941",
    "data-name": "Path 103941",
    d: "M138.033,290.33H110.315l22.858-186.348h22.308a7.04,7.04,0,0,1,5.139,2.213Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103942",
    "data-name": "Path 103942",
    d: "M105.34,290.33H99.1l22.858-186.348H128.2Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47919",
    "data-name": "Group 47919"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x2: 50.341,
    transform: "translate(103.176 185.404)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x2: 39.431,
    transform: "translate(109.67 192.848)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47922",
    "data-name": "Group 47922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47920",
    "data-name": "Group 47920",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103943",
    "data-name": "Path 103943",
    d: "M104.678,151.078l.069,1.978h-1.29l-.069-1.994-2.285-3.589h1.371l1.576,2.481,1.4-2.481h1.267Z",
    fill: "#25084b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103944",
    "data-name": "Path 103944",
    d: "M106.772,150.265a2.771,2.771,0,0,1,2.95-2.888,3.011,3.011,0,0,1,3.152,2.888,2.77,2.77,0,0,1-2.949,2.887A3.012,3.012,0,0,1,106.772,150.265Zm4.795,0a1.773,1.773,0,0,0-1.806-1.786,1.633,1.633,0,0,0-1.682,1.786,1.774,1.774,0,0,0,1.807,1.786A1.633,1.633,0,0,0,111.567,150.265Z",
    fill: "#25084b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103945",
    "data-name": "Path 103945",
    d: "M113.814,150.6l-.109-3.127H115l.107,3.079c.038,1.061.515,1.5,1.3,1.5s1.227-.438,1.19-1.5l-.108-3.079h1.275l.109,3.127a2.22,2.22,0,0,1-2.434,2.552A2.4,2.4,0,0,1,113.814,150.6Z",
    fill: "#25084b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103946",
    "data-name": "Path 103946",
    d: "M123.782,153.056l-1.13-1.555h-1.187l.054,1.555h-1.29l-.195-5.583h2.413c1.49,0,2.448.774,2.492,2.026a1.738,1.738,0,0,1-1.085,1.763l1.314,1.794Zm-1.369-4.53H121.36l.069,1.946h1.051c.789,0,1.174-.367,1.153-.973S123.2,148.526,122.413,148.526Z",
    fill: "#25084b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103947",
    "data-name": "Path 103947",
    d: "M127.895,150.265a2.752,2.752,0,0,1,2.925-2.888,2.982,2.982,0,0,1,2.329.99l-.8.765a1.858,1.858,0,0,0-1.424-.653,1.643,1.643,0,0,0-1.722,1.786,1.784,1.784,0,0,0,1.847,1.786,1.708,1.708,0,0,0,1.378-.662l.855.766a2.76,2.76,0,0,1-2.266,1A2.987,2.987,0,0,1,127.895,150.265Z",
    fill: "#25084b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103948",
    "data-name": "Path 103948",
    d: "M133.619,150.265a2.77,2.77,0,0,1,2.949-2.888,3.012,3.012,0,0,1,3.153,2.888,2.771,2.771,0,0,1-2.95,2.887A3.012,3.012,0,0,1,133.619,150.265Zm4.795,0a1.774,1.774,0,0,0-1.807-1.786,1.632,1.632,0,0,0-1.681,1.786,1.773,1.773,0,0,0,1.806,1.786A1.634,1.634,0,0,0,138.414,150.265Z",
    fill: "#25084b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103949",
    "data-name": "Path 103949",
    d: "M140.6,147.473h2.533a2.9,2.9,0,0,1,3.172,2.792,2.672,2.672,0,0,1-2.977,2.791h-2.533Zm2.627,4.522a1.6,1.6,0,0,0,1.771-1.73,1.734,1.734,0,0,0-1.893-1.731h-1.178l.121,3.461Z",
    fill: "#25084b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103950",
    "data-name": "Path 103950",
    d: "M151.66,152.019l.036,1.037h-4.317l-.195-5.583H151.4l.037,1.037H148.5l.042,1.212h2.589l.036,1.005H148.58l.045,1.292Z",
    fill: "#25084b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "****",
    transform: "translate(101 185.73)",
    fill: "#263238",
    fontSize: 29,
    fontFamily: "Poppins-Regular, Poppins",
    letterSpacing: "0.005em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "****"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47925",
    "data-name": "Group 47925"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    x2: 1.773,
    y2: 24.171,
    transform: "translate(76.719 125.636)",
    fill: "none",
    stroke: "#220345",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x2: 0.468,
    y2: 6.378,
    transform: "translate(75.911 114.625)",
    fill: "none",
    stroke: "#220345",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47927",
    "data-name": "Group 47927"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    y1: 14.716,
    transform: "translate(123.37 75.877)",
    fill: "none",
    stroke: "#2bb567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x1: 7.355,
    y1: 12.736,
    transform: "translate(104.366 80.97)",
    fill: "none",
    stroke: "#2bb567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    x1: 7.355,
    y2: 12.742,
    transform: "translate(135.019 80.97)",
    fill: "none",
    stroke: "#2bb567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47952",
    "data-name": "Group 47952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47950",
    "data-name": "Group 47950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47934",
    "data-name": "Group 47934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103974",
    "data-name": "Path 103974",
    d: "M172.51,419.2a1.174,1.174,0,0,0,.74-.88.69.69,0,0,0-.161-.688c-.77-.805-3.9-.234-4.253-.166a.208.208,0,0,0-.164.158.2.2,0,0,0,.083.21,10.721,10.721,0,0,0,2.03,1.156A2.557,2.557,0,0,0,172.51,419.2Zm.276-1.286a.288.288,0,0,1,.06.3.773.773,0,0,1-.479.6c-.567.2-1.652-.179-2.953-1.031C170.671,417.59,172.381,417.485,172.786,417.913Z",
    fill: "#1c0c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103975",
    "data-name": "Path 103975",
    d: "M168.9,417.87c.957-.119,3.158-1.249,3.352-2.227a.71.71,0,0,0-.428-.791,1.1,1.1,0,0,0-.922-.077c-1.207.414-2.181,2.715-2.222,2.813a.2.2,0,0,0,.028.2.211.211,0,0,0,.086.065A.223.223,0,0,0,168.9,417.87Zm2.72-2.661c.234.129.242.258.223.356-.118.6-1.584,1.52-2.611,1.816.365-.75,1.086-1.971,1.807-2.218a.684.684,0,0,1,.5.006A.808.808,0,0,1,171.623,415.209Z",
    fill: "#1c0c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103976",
    "data-name": "Path 103976",
    d: "M159.409,413.84l8.141,3.29,7.1-18.81-8.141-3.29Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103977",
    "data-name": "Path 103977",
    d: "M168.582,416.464l-9.146-3.7a.7.7,0,0,0-.878.284l-4.014,6.7a1.382,1.382,0,0,0,.711,1.952c3.211,1.235,4.824,1.672,8.846,3.3,2.475,1,5.984,2.714,9.4,4.1,3.342,1.351,4.987-1.87,3.69-2.747-5.816-3.928-6.047-6.2-7.455-8.843A2.28,2.28,0,0,0,168.582,416.464Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103978",
    "data-name": "Path 103978",
    d: "M174.551,407.549l-14.139-5.715,1.295-5.182,15.171,5.55Z",
    fill: "#1c0c5c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47943",
    "data-name": "Group 47943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103979",
    "data-name": "Path 103979",
    d: "M188.707,189.834c-2.868,8.3-11.361,27.863-17.9,19.716a18.821,18.821,0,0,1-2.858-4.76c-2.778-6.854-3.461-17.954-3.813-20.38L161.9,176.8a1.458,1.458,0,0,1-.06-.4l-.036-4.345c0-1.762,1.419-2.808,3.341-2.647,0,0,3.1-.363,3.1,1.489l.6,6.522h-.02c.312,2.274-.594,5.434-.061,7.518,1.993,7.83,4.749,8.181,6.48,16.263,2.406-5.827,6.723-15.922,6.723-15.922C184.883,185.638,189.653,187.1,188.707,189.834Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103980",
    "data-name": "Path 103980",
    d: "M178.452,212.534a5.156,5.156,0,0,1-8.47.289,18.978,18.978,0,0,1-2.767-5.195c-2.6-8.524-4.207-13.808-4.428-22.715a7.018,7.018,0,0,1,7.226-1.711l4.257,14.432s8.675-21.55,12.177-22.324c4.137-.906,5.858,2.78,7.6,7.319C195.3,185.9,184.1,203.817,178.452,212.534Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47942",
    "data-name": "Group 47942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47941",
    "data-name": "Group 47941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103981",
    "data-name": "Path 103981",
    d: "M213.481,153.745c-.981,5-3.184,15.914.316,19.252,0,0-1.367,5.074-10.662,5.074-10.22,0-4.884-5.073-4.884-5.073,5.578-1.332,5.434-5.471,4.462-9.358Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103982",
    "data-name": "Path 103982",
    d: "M197.848,141.948a.4.4,0,0,0,.357-.579,3.962,3.962,0,0,0-2.9-2.213.4.4,0,0,0-.092.794h0a3.163,3.163,0,0,1,2.274,1.777A.4.4,0,0,0,197.848,141.948Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103983",
    "data-name": "Path 103983",
    d: "M194.8,146.319a18.154,18.154,0,0,1-2.939,4.009,2.926,2.926,0,0,0,2.35.75Z",
    fill: "#ed893e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103984",
    "data-name": "Path 103984",
    d: "M195.6,144.856c.144.665-.092,1.28-.526,1.374s-.9-.368-1.047-1.033.091-1.279.525-1.373S195.459,144.192,195.6,144.856Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103985",
    "data-name": "Path 103985",
    d: "M194.756,143.819l-1.7-.114S194.149,144.774,194.756,143.819Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103986",
    "data-name": "Path 103986",
    d: "M159.979,169.052v.02c0-.01-.01-.01-.01-.02Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103987",
    "data-name": "Path 103987",
    d: "M188.347,185.566c1.771-1.621,2.968-1.137,3.784.151.805,3.744-3.966,11.584-5.888,14.552Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103988",
    "data-name": "Path 103988",
    d: "M229.3,190.5c-.23,4.12-.62,9.309-1.25,15.84-.66,6.889-1.6,15.259-2.89,25.429-13.59,0-27.82-.21-34.43-.21.553-13.508.758-27.194-5.3-54.08a2.545,2.545,0,0,1,2.033-3.065A98.022,98.022,0,0,1,199.384,173a108.94,108.94,0,0,1,15.55,0c6.67.609,14.25,2.16,14.25,2.16S230.024,177.636,229.3,190.5Z",
    fill: "#404245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103989",
    "data-name": "Path 103989",
    d: "M229.3,190.5c-.23,4.12-.62,9.309-1.25,15.84-3.66-4.241-7.12-18.84-6.02-23.83a32.752,32.752,0,0,1,7.11,7.2A7.327,7.327,0,0,1,229.3,190.5Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47937",
    "data-name": "Group 47937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47935",
    "data-name": "Group 47935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103990",
    "data-name": "Path 103990",
    d: "M264.593,208.8l6.965-3.916,1.3,7.13s-5.9,2.261-9.027.677Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103991",
    "data-name": "Path 103991",
    d: "M276.222,205.694l.484,2.327a1.847,1.847,0,0,1-.77,1.9l-3.077,2.09-1.3-7.13,2.408-.6A1.845,1.845,0,0,1,276.222,205.694Z",
    fill: "#ffb573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47936",
    "data-name": "Group 47936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103992",
    "data-name": "Path 103992",
    d: "M222.6,183.421c2.232,4.541,10.418,21.688,14.016,25.652l.7.738.352.368c.121.124.217.234.409.4a12.405,12.405,0,0,0,2.122,1.605,16.366,16.366,0,0,0,4.361,1.76,30.585,30.585,0,0,0,8.18.776,59.957,59.957,0,0,0,15.1-2.564l-.894-4.175c-2.3.2-4.727.338-7.07.377a56.221,56.221,0,0,1-6.95-.22,27.029,27.029,0,0,1-6.3-1.225,9.438,9.438,0,0,1-2.325-1.175,4.544,4.544,0,0,1-.744-.663,3.071,3.071,0,0,1-.225-.257l-.261-.313-.522-.621c-2.764-3.46-10.053-20.137-12.241-24.307Z",
    fill: "#ffb573"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_103993",
    "data-name": "Path 103993",
    d: "M264.483,215.9a24.615,24.615,0,0,1-18.749,1.822,25.081,25.081,0,0,1-14.09-11.413c-3.613-5.314-13.223-20.333-12.015-24.217,1.429-4.64,4.468-7.518,9.55-6.271,3.573.866,10.386,18.2,13.677,25.134,1.3,1.933,3.774,4.992,6.541,5.938,4.892,1.691,8.495.956,13.617.231.936.564.866,1.43,1.339,2.406A7.264,7.264,0,0,1,264.483,215.9Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103994",
    "data-name": "Path 103994",
    d: "M218.523,145.725c-1.534,8.225-2.008,11.739-6.72,15.475-7.088,5.619-16.854,1.936-17.808-6.581-.858-7.667,1.795-19.829,10.315-22.123A11.411,11.411,0,0,1,218.523,145.725Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47938",
    "data-name": "Group 47938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103995",
    "data-name": "Path 103995",
    d: "M247.7,191.24c-1.57,1.79-2.065,2.826-4.245,3.8s-6.939.125-8.449-1.725c.49,1.44,3.354,4.029,4.854,4.229a8.493,8.493,0,0,1-10.46-1.84,5.414,5.414,0,0,0,3.56,3.91c-19.163.495-11.094-8.523-23.086-21.346-13.285-14.205-10.4-25.944-10.4-25.944a13.544,13.544,0,0,0-2.61-8.14c-1.92-2.46-1.36-5.78-.75-7.64.89-2.73,3.6-3.69,6.2-3.85.458-2.694,5.962-2.2,6.666-1.748.6.386.758.353,1.362-.033,1.353-.867,4.752-1.773,8.392,1.171,2.222,1.8,4.6,5.02,4.675,11.88.083,7.134-3.321,15.6,8.471,26.435C238.825,176.782,235.5,190.492,247.7,191.24Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_103996",
    "data-name": "Path 103996",
    d: "M197.89,146.346a6.265,6.265,0,0,0-1.078,4.544c.335,2.111,2.393,2.251,3.883.9,1.341-1.218,2.782-3.784,1.684-5.534A2.645,2.645,0,0,0,197.89,146.346Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47939",
    "data-name": "Group 47939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103997",
    "data-name": "Path 103997",
    d: "M216.448,231.763s-4.083,57.407-8.692,95.272a93.288,93.288,0,0,1-10.215,32.473l-22.587,42.558-11.561-4.547s7.964-40.454,23.583-62.511c0,0-11.658-65.93,3.6-103.447Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_103998",
    "data-name": "Path 103998",
    d: "M200.728,245.665s3.438,26.041,5.327,41.472C198.963,277.836,193.532,264.861,200.728,245.665Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47940",
    "data-name": "Group 47940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103999",
    "data-name": "Path 103999",
    d: "M245.641,424.59a1.153,1.153,0,0,0,.236-1.119.7.7,0,0,0-.47-.534c-1.064-.356-3.556,1.59-3.836,1.814a.2.2,0,0,0-.07.214.206.206,0,0,0,.172.148,10.83,10.83,0,0,0,2.344.086A2.546,2.546,0,0,0,245.641,424.59Zm-.368-1.264a.292.292,0,0,1,.2.242.767.767,0,0,1-.14.747c-.4.441-1.546.6-3.1.45C243.251,424.015,244.711,423.135,245.273,423.326Z",
    fill: "#170a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104000",
    "data-name": "Path 104000",
    d: "M241.821,425.077c.79-.546,2.2-2.559,1.9-3.512a.725.725,0,0,0-.755-.5,1.089,1.089,0,0,0-.851.358c-.87.921-.635,3.4-.624,3.509a.2.2,0,0,0,.12.166.213.213,0,0,0,.108.018A.2.2,0,0,0,241.821,425.077Zm1.138-3.6c.268.006.337.116.366.211.179.581-.675,2.074-1.443,2.808a4.625,4.625,0,0,1,.541-2.792.674.674,0,0,1,.442-.223C242.9,421.474,242.927,421.473,242.959,421.473Z",
    fill: "#170a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104001",
    "data-name": "Path 104001",
    d: "M231.516,425.892l8.759-.844L237.6,405.153l-8.759.844Z",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104002",
    "data-name": "Path 104002",
    d: "M240.869,423.983l-9.84.948a.691.691,0,0,0-.641.656l-.358,7.769a1.405,1.405,0,0,0,1.556,1.4c3.425-.389,5.059-.746,9.386-1.163,2.662-.257,6.579-.36,10.255-.714,3.6-.346,3.517-3.95,1.954-4.127-7.009-.791-8.293-2.69-10.795-4.378A2.32,2.32,0,0,0,240.869,423.983Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104003",
    "data-name": "Path 104003",
    d: "M225.111,231.749s11.205,68.511,13.364,109.1l.4,72.7-9.066,1.768s-13.136-46.378-14.648-73.184c-4.01-71.128-27.176-71.245-13.238-110.5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104004",
    "data-name": "Path 104004",
    d: "M241.889,413.837l-15.013,2.056-1.521-5.766,16.046-2.087Z",
    fill: "#170a53"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_104005",
    "data-name": "Path 104005",
    d: "M160,169.123h-.03l.01-.051C159.979,169.093,159.989,169.1,160,169.123Z",
    fill: "#ffb573"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47949",
    "data-name": "Group 47949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47948",
    "data-name": "Group 47948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47947",
    "data-name": "Group 47947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47944",
    "data-name": "Group 47944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104006",
    "data-name": "Path 104006",
    d: "M160.961,158.253h.574a.982.982,0,0,0-.991,1.046l.913,17.414a1.114,1.114,0,0,0,1.1,1.046h-.574a1.114,1.114,0,0,1-1.1-1.046L159.97,159.3A.983.983,0,0,1,160.961,158.253Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104007",
    "data-name": "Path 104007",
    d: "M160.961,158.253h.574a.982.982,0,0,0-.991,1.046l.913,17.414a1.114,1.114,0,0,0,1.1,1.046h-.574a1.114,1.114,0,0,1-1.1-1.046L159.97,159.3A.983.983,0,0,1,160.961,158.253Z",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_104008",
    "data-name": "Path 104008",
    d: "M162.154,177.759h7.024a.982.982,0,0,0,.991-1.046l-.912-17.414a1.115,1.115,0,0,0-1.1-1.046h-7.024a.983.983,0,0,0-.991,1.046l.913,17.414A1.114,1.114,0,0,0,162.154,177.759Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104009",
    "data-name": "Path 104009",
    d: "M162.154,177.759h7.024a.982.982,0,0,0,.991-1.046l-.912-17.414a1.115,1.115,0,0,0-1.1-1.046h-7.024a.983.983,0,0,0-.991,1.046l.913,17.414A1.114,1.114,0,0,0,162.154,177.759Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47945",
    "data-name": "Group 47945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104010",
    "data-name": "Path 104010",
    d: "M169.73,176.35a.647.647,0,0,1-.17.48.665.665,0,0,1-.47.19h-6.81a.753.753,0,0,1-.74-.71l-.89-16.89a.61.61,0,0,1,.17-.47.634.634,0,0,1,.47-.2h6.81a.753.753,0,0,1,.74.71l.06,1.21Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47946",
    "data-name": "Group 47946",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104011",
    "data-name": "Path 104011",
    d: "M168.9,160.67l-2.26,16.35h-2.71l2.56-18.27h1.61a.753.753,0,0,1,.74.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104012",
    "data-name": "Path 104012",
    d: "M162.95,177.02h-.611l2.561-18.27h.611Z",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_104013",
    "data-name": "Path 104013",
    d: "M188.521,233.7a73.95,73.95,0,0,0-8.032,32.347c17.023,13.189,32.831-2.257,52.289.352-.679-8.788-3.664-25.049-7.21-33.119C212.71,233.825,200.668,232.542,188.521,233.7Z",
    fill: "#404245"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47951",
    "data-name": "Group 47951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104014",
    "data-name": "Path 104014",
    d: "M190.292,230.133s-1.374,3.522-.98,3.522h35.676c.307,0,.561-.15.58-.343l.307-3.045c.022-.211-.244-.389-.58-.389H190.846A.616.616,0,0,0,190.292,230.133Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_104015",
    "data-name": "Path 104015",
    d: "M195.318,233.955H194.4c-.184,0-.324-.1-.311-.21l.432-3.957c.013-.116.174-.21.357-.21h.923c.184,0,.324.094.311.21l-.433,3.957C195.663,233.86,195.5,233.955,195.318,233.955Z",
    fill: "#2bb567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104016",
    "data-name": "Path 104016",
    d: "M217.682,233.955h-.923c-.183,0-.323-.1-.311-.21l.433-3.957c.013-.116.173-.21.357-.21h.923c.184,0,.324.094.311.21l-.433,3.957C218.027,233.86,217.866,233.955,217.682,233.955Z",
    fill: "#2bb567"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/otp.3573ac8edafde639d2a76aa8ef87d525.svg";
export { ForwardRef as ReactComponent };